import React from 'react';
import { Image } from '@skin-seoul/design-system';
import { type TaxonomyCategory } from '../utils/categoryUtils';
interface CategoryImageProps {
  category: TaxonomyCategory;
}
const CategoryImage = ({
  category
}: CategoryImageProps) => {
  if (!category.thumbnailImageUrl) {
    return null;
  }
  return <Image src={category.thumbnailImageUrl} alt={category.name} width="48px" height="48px" borderRadius="50%" objectFit="cover" data-sentry-element="Image" data-sentry-component="CategoryImage" data-sentry-source-file="CategoryImage.tsx" />;
};
export default CategoryImage;